// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Dw","input":"i_Dx","label":"i_Dy","wrap":"i_Dz","text":"i_D0"};